import React from "react";
import { useParams } from "react-router-dom";
import Theme404 from "../../layout/404";

import ads_list from "./ads.list";
import ads_edit from "./ads.edit";

/**
 *   Create index file for Prompt
 */

export default function List_prompt() {
  let useParam = {} as any;
  useParam = useParams();
  let Param = useParam.slug || "list";

  let ActualPage: any;
  switch (Param) {
    case "list":
      ActualPage = ads_list;
      break;

    case "edit":
      ActualPage = ads_edit;
      break;

    case "new":
      ActualPage = ads_edit;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}
